import type { ResolveDashboardPeriodLabelParams } from '../types';
import resolveLiveTabPeriodLabel from './resolveLiveTabPeriodLabel';

const resolveDashboardPeriodLabel = ({
    activeTabId,
    overviewPeriodLabel,
    isLoadingOverview,
    hasOverviewError,
    growthPeriodLabel,
    isLoadingGrowth,
    hasGrowthError,
    mockPeriodLabel,
}: ResolveDashboardPeriodLabelParams): string => {
    if (activeTabId === 'summary') {
        return resolveLiveTabPeriodLabel({
            periodLabel: overviewPeriodLabel,
            isLoading: isLoadingOverview,
            hasError: hasOverviewError,
        });
    }

    if (activeTabId === 'growth') {
        return resolveLiveTabPeriodLabel({
            periodLabel: growthPeriodLabel,
            isLoading: isLoadingGrowth,
            hasError: hasGrowthError,
        });
    }

    return mockPeriodLabel;
};

export default resolveDashboardPeriodLabel;
